// import { useLocation } from "react-router-dom";

// const ProductDetails = () => {
//     const location = useLocation();
//     const property = location.state;

//     if (!property) return <div>No data</div>;

//     return (
//         <div style={{ padding: 20 }}>
//             <h2>{property.title}</h2>
//             <p>{property.description}</p>
//             <p>Location: {property.location}</p>
//             <p>Category: {property.category}</p>
//             <p>Area: {property.area}</p>
//             <p>Price: ₹{property.price}</p>

//             {property.property_images.map((img, i) => (
//                 <img key={i} src={img} width="300" />
//             ))}
//         </div>
//     );
// };

// export default ProductDetails;



import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AgentNavBar from "./AgentNavBar";

const ProductDetails = () => {
  const location = useLocation();
  const property = location.state;

  const [activeImage, setActiveImage] = useState(0);
  const [similar, setSimilar] = useState([]);

  useEffect(() => {
    fetch("https://api.propertygalleria.in/master/api/get/owner/properties")
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          const related = data.data.filter(
            p => p.category === property.category && p.id !== property.id
          );
          setSimilar(related.slice(0, 3));
        }
      });
  }, [property]);

  if (!property) return <div>No property found</div>;

  const images = property.property_images || [];

  return (
    <>
    <AgentNavBar/>
    <div style={{ padding: 20,marginTop:'5%' }}>

      {/* ---------- GALLERY ---------- */}
      <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
        
        {/* Main image */}
        <div style={{ flex: 2 }}>
          <img
            src={images[activeImage]}
            style={{
              width: "100%",
              height: 400,
              objectFit: "cover",
              borderRadius: 12,
              cursor: "zoom-in"
            }}
            onClick={() => window.open(images[activeImage])}
            alt=""
          />

          {/* thumbnails */}
          <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
            {images.map((img, i) => (
              <img
                key={i}
                src={img}
                onClick={() => setActiveImage(i)}
                style={{
                  width: 80,
                  height: 60,
                  objectFit: "cover",
                  cursor: "pointer",
                  border:
                    i === activeImage
                      ? "3px solid #007bff"
                      : "1px solid #ccc",
                  borderRadius: 6
                }}
              />
            ))}
          </div>
        </div>

        {/* ---------- DETAILS ---------- */}
        <div style={{ flex: 1 }}>
          <h2>{property.title}</h2>

          <p>📍 {property.location}</p>
          <p>Category: {property.category}</p>
          <p>Area: {property.area} sq ft</p>

          <h3 style={{ color: "#007bff" }}>
            ₹ {Number(property.price).toLocaleString()}
          </h3>

          <p>{property.description}</p>

          {/* Buttons */}
          <button style={btnStyle}>
            📞 Contact Agent
          </button>

          <button style={{ ...btnStyle, background: "#28a745" }}>
            ✉️ Send Inquiry
          </button>
        </div>
      </div>

      {/* ---------- MAP ---------- */}
      <div style={{ marginTop: 40 }}>
        <h3>Location</h3>

        <iframe
          width="100%"
          height="350"
          style={{ border: 0, borderRadius: 12 }}
          loading="lazy"
          allowFullScreen
          src={`https://www.google.com/maps?q=${property.location}&output=embed`}
        ></iframe>
      </div>

      {/* ---------- SIMILAR ---------- */}
      <div style={{ marginTop: 40 }}>
        <h3>Similar Properties</h3>

        <div style={{ display: "flex", gap: 20, flexWrap: "wrap" }}>
          {similar.map(p => (
            <div
              key={p.id}
              style={{
                width: 260,
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 3px 10px rgba(0,0,0,0.1)"
              }}
            >
              <img
                src={p.property_images?.[0]}
                style={{
                  width: "100%",
                  height: 150,
                  objectFit: "cover",
                  borderTopLeftRadius: 12,
                  borderTopRightRadius: 12
                }}
              />
              <div style={{ padding: 10 }}>
                <h4>{p.title}</h4>
                <p>{p.location}</p>
                <b>₹ {Number(p.price).toLocaleString()}</b>
              </div>
            </div>
          ))}
        </div>
      </div>

    </div>

    </>
  );
};

const btnStyle = {
  width: "100%",
  padding: 12,
  marginTop: 10,
  border: "none",
  borderRadius: 8,
  background: "#007bff",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

export default ProductDetails;
